import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getPerformance } from 'firebase/performance';
// import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

import { firebaseConfig } from './config';

export let firebaseApp: FirebaseApp;

if (getApps().length) {
  firebaseApp = getApp();
} else {
  firebaseApp = initializeApp(firebaseConfig);
}

// initializeAppCheck(firebaseApp, {
//   provider: new ReCaptchaEnterpriseProvider('6LelEKwqAAAAAGx9p-r7CZMViVsB4-TXDvWYyL0a'),
//   isTokenAutoRefreshEnabled: true
// });

export const auth = getAuth(firebaseApp);
export const functions = getFunctions(firebaseApp);
export const firestore = getFirestore(firebaseApp);
export const performance = getPerformance(firebaseApp);


